import * as actions from "./actions"
import { ActionType } from "typesafe-actions"

export enum AnalyticsActionTypes {
	EmitAnalyticEvent = "analytics/EMIT_ANALYTIC_EVENT",
}

export type TAnalyticsAction = ActionType<typeof actions>
